<script lang="ts">
import { page } from '$app/stores'
import { capatilize } from '$lib/helpers';

export let list : [] = []
</script>
{#if list.length > 0}
    <div class="links">
        <h2>Hire more <span>developer roles</span> on OfferZen</h2>
        <ul class="links__section">
            {#each list as url}
                {#if url.slug?.current !== $page.params.page}
                    <li><a href="{import.meta.env.VITE_VERCEL_ENV === 'production' ? `/hire-developers/${url.slug?.current}` : url.slug?.current}" data-sveltekit-reload>Hire {capatilize(url.title, ['iOS'])}s</a></li>
                {/if}
            {/each}
        </ul>
    </div>
{/if}
<style lang="postcss">
    @import '../../styles/_mixins.css';
    .links {
        display: grid;
        justify-content: center;
        padding:120px 0 96px;

        & h2 {
            text-align: center;
            @mixin heading-h2;
            color:var(--color_white);
            margin: 0 0 60px;

            & span {
                color:var(--color_offerzen_cerulean);
            }

            @mixin screen-sm {
                margin: 0 0 40px;
                text-align:left;
            }
        }

        @mixin screen-lg {
            padding:120px 80px 96px;
        }

        @mixin screen-md {
            padding:100px 60px 60px;
        }

        @mixin screen-sm {
            padding:60px 24px 36px;
            flex-direction:column;
            gap:0px;
        }

        & .links__section {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            list-style-type: none;
            padding:0;
            margin:0;
            gap:0px 120px;

            @mixin screen-lg {
                gap:0px 105px;
            }

            @mixin screen-md {
                gap:0;
                grid-template-columns: 1fr 1fr;
                max-width:600px;
                justify-self:center;
            }

            @mixin screen-sm {
                grid-template-columns:1fr;
                gap:0;
                width:100%;
            }

            & li {
                margin:0 0 24px;

                @mixin screen-md {
                    margin:0 0 40px;
                    padding:0 0 0 40px
                }

                @mixin screen-sm {
                    padding:0px;
                }

                & a {
                    font-size:18px;
                    text-decoration: none;
                    color:var(--color_white);
                    line-height:130%;

                    &:hover {
                        color:var(--color_offerzen_cerulean);
                    }

                }
            }
        }
    }
</style>